export function apiExportUrl(path, params = {}) {
  const query = new URLSearchParams(params).toString()
  return `/api/exportacao/${path}${query ? `?${query}` : ''}`
}
